var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.toastOnly === false)?_c('base-alert',{attrs:{"dismissible":"","type":"success","icon":"ni ni-like-2"}},[_vm._v(" "+_vm._s(_vm.message)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }